var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PharmacistsRequests", {
    attrs: {
      appointment: _vm.appointment,
      pharmacy: _vm.pharmacy,
      assignedPharmacist: _vm.assignedPharmacist,
      knownPharmacists: _vm.knownPharmacists,
      numOfRequests: _vm.numOfRequests,
      "selection-enabled": false,
      "hydrate-on-dialog-open": true,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }